var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-cascader',{staticStyle:{"width":"250px"},attrs:{"size":"large","options":_vm.areaRegionData,"props":_vm.props,"disabled":_vm.isShow,"clearable":"","filterable":""},model:{value:(_vm.tValue),callback:function ($$v) {_vm.tValue=$$v},expression:"tValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }